import React from "react";
import { OTHER_DEPARTMENTS_GROUP_LABEL } from "@features/department/constants/departmentIds";
import {
  DepartmentSelectItem,
  partitionDepartmentsForSelect,
} from "@features/department/utils/partitionDepartmentsForSelect";

type Props = {
  departments: DepartmentSelectItem[];
  /** When true, option values are strings (e.g. ActivityFormSelector). */
  stringValues?: boolean;
};

/**
 * Renders Main Office first, then an Other departments optgroup.
 */
const DepartmentSelectOptions: React.FC<Props> = ({ departments, stringValues = false }) => {
  const { mainOffice, others } = partitionDepartmentsForSelect(departments);

  const valueOf = (id: number) => (stringValues ? String(id) : id);

  return (
    <>
      {mainOffice && (
        <option key={mainOffice.department_id} value={valueOf(mainOffice.department_id)}>
          {mainOffice.name}
        </option>
      )}
      {others.length > 0 && (
        <optgroup label={OTHER_DEPARTMENTS_GROUP_LABEL}>
          {others.map((dept) => (
            <option key={dept.department_id} value={valueOf(dept.department_id)}>
              {dept.name}
            </option>
          ))}
        </optgroup>
      )}
    </>
  );
};

export default DepartmentSelectOptions;
